import { TPosthogIdentity } from "./types";

export const isPosthogTraceableStage = (
    { stage, stages = ["production"] }: { stage: string | undefined; stages?: string[] }
): boolean => {

    if (stage && stages.includes(stage)) {
        return true
    };
    return false;
};

export const generatePosthogIdentity = (
    id: string,
    email?: string
): TPosthogIdentity => ({
    identityId: id,
    isTrilo: email?.includes("@trilo.io") || false,
});
